"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Icon_1 = require("../Icon");
var Table_1 = require("../Table");
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table() {
        var _this = _super.call(this) || this;
        _this.handleHeaderClick = _this.handleHeaderClick.bind(_this);
        _this.handleRowClick = _this.handleRowClick.bind(_this);
        return _this;
    }
    Table.prototype.handleHeaderClick = function (columnIndex) {
        if (this.props.headerClick) {
            this.props.headerClick(columnIndex);
        }
    };
    Table.prototype.handleRowClick = function (row) {
        if (this.props.navigateRow) {
            this.props.navigateRow(row);
        }
        else if (this.props.navigateColumn) {
            this.props.navigateColumn(row);
        }
    };
    Table.prototype.render = function () {
        var _this = this;
        var childCount = React.Children.count(this.props.children);
        // Turn column definitions into columns
        var head = React.Children.map(this.props.children, function (child, childIndex) {
            var columnDefinition = child;
            var getSort = function () {
                if (!_this.props.sortedColumnName || !_this.props.sortedColDirection) {
                    return "unsorted";
                }
                return columnDefinition.props.columnName === _this.props.sortedColumnName ? _this.props.sortedColDirection : "unsorted";
            };
            var columnProps = { header: columnDefinition.props.header, colIndex: childIndex, columnName: columnDefinition.props.columnName, sort: getSort(), headerClick: _this.handleHeaderClick, isHidden: columnDefinition.props.isHidden, headerNowrap: columnDefinition.props.headerNowrap };
            return React.createElement(Table_1.ColumnHeader, __assign({}, columnProps));
        });
        if (this.props.navigateRow || this.props.navigateColumn) {
            head.push(React.createElement("th", { key: "col-head-" + childCount }));
        }
        var rows;
        if (this.props.data) {
            // Turn data into rows
            rows = this.props.data.map(function (row, index) {
                // Turn column definitions into cells
                var cols = React.Children.map(_this.props.children, function (child, childIndex) {
                    var columnDefinition = child;
                    var cellProps = __assign({}, columnDefinition.props, { row: row, rowIndex: index, colIndex: childIndex });
                    return React.createElement(Table_1.Cell, __assign({}, cellProps));
                });
                if (_this.props.navigateRow) {
                    cols.push(React.createElement("td", { key: "row-" + (index + 1) + "-col-" + childCount },
                        React.createElement(Icon_1.Icon, { icon: 'right' })));
                }
                else if (_this.props.navigateColumn) {
                    // tslint:disable-next-line:jsx-no-lambda
                    cols.push(React.createElement("td", { className: 'clickable', key: "row-" + (index + 1) + "-col-" + childCount, onClick: function () { return _this.handleRowClick(row); } },
                        React.createElement(Icon_1.Icon, { icon: 'right' })));
                }
                if (_this.props.navigateRow) {
                    // tslint:disable-next-line:jsx-no-lambda
                    return (React.createElement("tr", { className: "clickable", onClick: function () { return _this.handleRowClick(row); }, key: index }, cols));
                }
                else {
                    return (React.createElement("tr", { key: index }, cols));
                }
            });
        }
        else {
            rows = [];
        }
        var tableClass = classNames("table ", this.props.hover ? "table-hover" : null);
        if (rows.length > 0) {
            return (React.createElement("table", { className: tableClass },
                React.createElement("thead", null,
                    React.createElement("tr", null, head)),
                React.createElement("tbody", null, rows)));
        }
        else {
            return (React.createElement("div", { className: "table-responsive" },
                React.createElement("table", { className: tableClass },
                    React.createElement("thead", null,
                        React.createElement("tr", null, head))),
                React.createElement("div", { style: { textAlign: "center" } }, this.props.emptyMessage)));
        }
    };
    Table.defaultProps = {
        sortedColDirection: "unsorted"
    };
    return Table;
}(React.Component));
exports.Table = Table;
//# sourceMappingURL=Table.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Table/Table.js
// module id = 601
// module chunks = 1